import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isRecaptchaRendered: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = { message: null };
    public validationErrors: any[] = [];
    public recaptchaId: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get isInfoRequestVisible() {
        return this.$store.getters["infoRequestStore/isInfoRequestVisible"];
    }

    get message() {
        return this.$store.getters["infoRequestStore/message"];
    }

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly requestUrl: string;

    @Watch("isInfoRequestVisible") onInfoRequestVisibilityUpdate(newValue: boolean) {
        const vm = this;

        if (this.message) {
            this.formData.message = "Vorrei maggiori informazioni riguardanti il prodotto " + this.message;
        }

        if (newValue) {
            document.body.classList.add("overflow");
            (<any>this).$refs.infoRequestModal.classList.add("show");
            this.$nextTick(function () {
                if (!vm.isRecaptchaRendered) {
                    this.recaptchaId = (<any>window).grecaptcha.render(document.getElementById("recaptcha"), { "sitekey": this.recaptchaSiteKey });
                    vm.isRecaptchaRendered = true;
                } else {
                    (<any>window).grecaptcha.reset(this.recaptchaId);
                }
            });
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.infoRequestModal.classList.remove("show");
        }
    }

    public mounted() {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=explicit");
        document.head.appendChild(recaptchaScript);
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.originPage = this.requestUrl;

        try {
            await Axios.post(this.routes.Support_InfoRequest, this.formData, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse(this.recaptchaId) } });

            this.isSuccess = true;
            this.isRecaptchaRendered = false;

            GTagHelper.sendEvent("form_submit", "info_request");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }

            (<any>window).grecaptcha.reset(this.recaptchaId);
        }

        this.isLoading = false;
    }

    public closeInfoRequest() {
        this.$store.commit("infoRequestStore/setInfoRequestVisible", false);
        this.isLoading = false;
        this.isSuccess = false;
        this.formData = {};
        this.validationErrors = [];
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};